import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/abhay/Projects/kalalaya-academy/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/history
 */

/**
 * `History` keeps the track of all the operations applied to the {@link module:engine/model/document~Document document}.
 */
var History =
/*#__PURE__*/
function () {
  /**
   * Creates an empty History instance.
   */
  function History() {
    _classCallCheck(this, History);

    /**
     * Operations added to the history.
     *
     * @protected
     * @member {Array.<module:engine/model/operation/operation~Operation>} module:engine/model/history~History#_operations
     */
    this._operations = [];
    /**
     * Holds an information which {@link module:engine/model/operation/operation~Operation operation} undoes which
     * {@link module:engine/model/operation/operation~Operation operation}.
     *
     * Keys of the map are "undoing operations", that is operations that undone some other operations. For each key, the
     * value is an operation that has been undone by the "undoing operation".
     *
     * @private
     * @member {Map} module:engine/model/history~History#_undoPairs
     */

    this._undoPairs = new Map();
    /**
     * Holds all undone operations.
     *
     * @private
     * @member {Set.<module:engine/model/operation/operation~Operation>} module:engine/model/history~History#_undoneOperations
     */

    this._undoneOperations = new Set();
  }
  /**
   * Adds an operation to the history.
   *
   * @param {module:engine/model/operation/operation~Operation} operation Operation to add.
   */


  _createClass(History, [{
    key: "addOperation",
    value: function addOperation(operation) {
      if (this._operations.includes(operation)) {
        return;
      }

      this._operations.push(operation);
    }
    /**
     * Returns operations added to the history.
     *
     * @param {Number} [from=0] Base version from which operations should be returned (inclusive). Defaults to `0`, which means
     * that operations from the first one will be returned.
     * @param {Number} [to=Number.POSITIVE_INFINITY] Base version up to which operations should be returned (exclusive).
     * Defaults to `Number.POSITIVE_INFINITY` which means that operations up to the last one will be returned.
     * @returns {Iterable.<module:engine/model/operation/operation~Operation>} Operations added to the history.
     */

  }, {
    key: "getOperations",
    value: function getOperations() {
      var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.POSITIVE_INFINITY;

      if (from < 0) {
        return [];
      }

      return this._operations.slice(from, to);
    }
    /**
     * Returns operation from the history that bases on given `baseVersion`.
     *
     * @param {Number} baseVersion Base version of the operation to get.
     * @returns {module:engine/model/operation/operation~Operation|null} Operation with given base version or `null` if
     * there is no such operation in history.
     */

  }, {
    key: "getOperation",
    value: function getOperation(baseVersion) {
      return this._operations[baseVersion];
    }
    /**
     * Marks in history that one operation is an operation that is undoing the other operation. By marking operation this way,
     * history is keeping more context information about operations, which helps in operational transformation.
     *
     * @param {module:engine/model/operation/operation~Operation} undoneOperation Operation which is undone by `undoingOperation`.
     * @param {module:engine/model/operation/operation~Operation} undoingOperation Operation which undoes `undoneOperation`.
     */

  }, {
    key: "setOperationAsUndone",
    value: function setOperationAsUndone(undoneOperation, undoingOperation) {
      this._undoPairs.set(undoingOperation, undoneOperation);

      this._undoneOperations.add(undoneOperation);
    }
    /**
     * Checks whether given `operation` is undoing any other operation.
     *
     * @param {module:engine/model/operation/operation~Operation} operation Operation to check.
     * @returns {Boolean} `true` if given `operation` is undoing any other operation, `false` otherwise.
     */

  }, {
    key: "isUndoingOperation",
    value: function isUndoingOperation(operation) {
      return this._undoPairs.has(operation);
    }
    /**
     * Checks whether given `operation` has been undone by any other operation.
     *
     * @param {module:engine/model/operation/operation~Operation} operation Operation to check.
     * @returns {Boolean} `true` if given `operation` has been undone any other operation, `false` otherwise.
     */

  }, {
    key: "isUndoneOperation",
    value: function isUndoneOperation(operation) {
      return this._undoneOperations.has(operation);
    }
    /**
     * For given `undoingOperation`, returns the operation which has been undone by it.
     *
     * @param {module:engine/model/operation/operation~Operation} undoingOperation
     * @returns {module:engine/model/operation/operation~Operation|undefined} Operation that has been undone by given
     * `undoingOperation` or `undefined` if given `undoingOperation` is not undoing any other operation.
     */

  }, {
    key: "getUndoneOperation",
    value: function getUndoneOperation(undoingOperation) {
      return this._undoPairs.get(undoingOperation);
    }
  }]);

  return History;
}();

export { History as default };